

import watchNovaContaAgrare from './saga/new';
import watchFindContaAgrare from './saga/find';
import watchUpdateContaAgrare from './saga/update';
import watchDeleteContaAgrare from './saga/delete';
import watchListContaAgrare from './saga/listTable';
import watchNewFilterContaAgrare from './saga/newFilter';
import watchNewFilterNextPageContaAgrare from './saga/newFilterNextPage';
import watchUpdateDataUltimoAcessoContaAgrare from './saga/updateDataUltimoAcesso';
import watchBloquearContaAgrare from './saga/bloquear';
import watchDesbloquearContaAgrare from './saga/desbloquear';
import watchProrrogarTesteContaAgrare from './saga/prorrogarTeste';
import watchLiberarContaAgrare from './saga/liberar';

export const contaAgrareSaga = [
    watchNovaContaAgrare(),
    watchFindContaAgrare(),
    watchUpdateContaAgrare(),
    watchDeleteContaAgrare(),
    watchListContaAgrare(),
    watchNewFilterContaAgrare(),
    watchNewFilterNextPageContaAgrare(),
    watchUpdateDataUltimoAcessoContaAgrare(),
    watchBloquearContaAgrare(),
    watchDesbloquearContaAgrare(),
    watchProrrogarTesteContaAgrare(),
    watchLiberarContaAgrare(),
]

export * from './actionTypes';
export * from './reducer';
export * from './entity';
